import StateInterface from "../state-interface";

export const requirements_feed: StateInterface["requirements_feed"] = {
	requirements: [],
	requirements_count: 0,
	feed_count: 0,
	responded_count: 0,
	saved_count: 0,
	loading: false,
	initial_load_done: false,
	trigger_new_search: false,
	filter_transaction_type: "",
	filter_property_category: "",
	filter_property_type: "",
	filter_location: "",
	filter_budget_min: 0,
	filter_budget_max: 0,
	filter_poster_type: "",
	filter_sort_field: "created_at",
	filter_sort_order: "desc",
	filter_page_number: 1,
};
